import { createSelector } from 'reselect';

import { FeedPost } from 'types/models';

import { getMetaField, getPreview } from 'config';
import moment from 'moment';

const newsfeeds = (state: { newsfeeds: { items: FeedPost[] } }) =>
  state.newsfeeds.items;

export const newsfeedsSelector = createSelector([newsfeeds], data => {
  return data.map((item, index) => {
    let slug = '';

    if (item.slug) {
      slug = item.slug;
    }

    let object = {
      id: item.id,
      link: '/' + item.categories_path + '/' + slug,
      img: getPreview(
        item.get_post_types,
        item.announce_img,
        null,
        true,
        moment(item.publication_at),
        item.categories_path,
        item
      ),
      description: getMetaField('description', item.meta),
      title: item.title,
      date: moment(item.publication_at).format('DD.MM.YYYY'),
      tag:
        (item.get_categories &&
          item.get_categories[0] &&
          item.get_categories[0].title) ||
        '',
      type: '',
      isVideo:
        (item.get_post_types &&
          item.get_post_types[0] &&
          item.get_post_types[0].slug == 'video' &&
          true) ||
        false,
      exclusive_material: item.exclusive_material,
    };

    if (!index) {
      object = {
        ...object,
        tag: 'Видео',
        type: 'other',
      };
    }
    if (item.exclusive_material) {
      object = { ...object, tag: 'Эксклюзив' };
    }

    return object;
  });
});
